export const GOOGLE_IDP = "google-oauth2";
export const AUTH0_IDP = "auth0";
export const SAML_IDP = "samlp";

export const DISABLE_EDIT_ACCOUNT_SETTING_IDPS = [GOOGLE_IDP, SAML_IDP];
